/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.outages.rpc.FintechOutagesRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getZuoraOutageStatusRpc = {
  serviceName: 'com.hubspot.fintech.outages.rpc.FintechOutagesRpc',
  rpcName: 'getZuoraOutageStatus',
  auth: 'external',
  fingerprint: 'BNElolPHfTBOa9UICveTlpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};